"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var universalMethods = _interopRequireWildcard(require("./_universalmethods"));

var _assign = _interopRequireDefault(require("../_helpers/assign"));

var _afterinit = _interopRequireDefault(require("./_afterinit"));

var _default = (0, _assign["default"])({
  _afterInit: _afterinit["default"],
  isSeemple: true,
  $: universalMethods.selectAll
}, universalMethods);

exports["default"] = _default;
//# sourceMappingURL=_prototype.js.map